/* eslint-disable no-useless-concat */
/* eslint-disable default-case */
/* eslint-disable no-unused-vars */
import React from 'react';
import _ from 'underscore';
import './../../styles/css/group.css';
import config from '../../settings/config';
import Popover from '../others/Popover';
import { jsPDF } from 'jspdf';
import Rest from '../../Server/Rest';
import user from '../../settings/user';
import Spinner from '../others/Spinner';
import TableCountInfo from '../others/TableCountInfo';
import TablePagination from '../others/TablePagination';
import textUtils from '../../utilities/format-string';
import Parse from 'parse';
import TableOrder from '../others/TableOrder';
import requisitions_service from '../../services/requisitions';
import { Component } from 'react';
import DisbursmentAndPaymentFilter from './DisbursmentAndPaymentFilter';
import CreatePoliceForm from './CreatePoliceForm';
import RequisitionModel from '../../models/RequisitionModel';
import * as XLSX from 'xlsx';

class ListDisbursmentAndPayment extends Component {
  title = 'Asistente de Pólizas y Desembolsos';

  status = 'baja';
  limit = 50;

  order = '-updatedAt';
  className = '';
  data = {};

  state = {
    loading: false,
    filter_type: 'desembolsos',

    // datos de filtro
    nombre: '',
    promotor: '',
    // dateStart: '',
    // dateEnd: '',
    dateStart: new Date(),
    dateEnd: new Date(),
    monto_autorizado: 0.0,
    plazo: '',
    Sucursal: !_.isEmpty(Parse.User.current().toJSON().Sucursal)
      ? Parse.User.current().toJSON().Sucursal.objectId
      : '',
    tipoReporte: '',

    total: 0,
    collection: [],
    collectionAll: [],
  };

  buildWhereBase = (data = {}) => ({
    promotor: !_.isEmpty(data.promotor) ? data.promotor : undefined,
    status: { $nin: ['autorizacion', 'rechazado'] },
    prestamo_personalizado_periodicidad:
      data.prestamo_personalizado_periodicidad === 14
        ? 14
        : data.prestamo_personalizado_periodicidad === 7
        ? { $ne: 14 }
        : undefined,
    Grupo: !_.isEmpty(data.id_busqueda)
      ? {
          $inQuery: {
            where: {
              id_busqueda: data.id_busqueda,
            },
            className: 'Grupos',
          },
        }
      : undefined,
    Sucursal: data.Sucursal ? data.Sucursal : undefined,
    monto_autorizado: data.monto_autorizado ? data.monto_autorizado : undefined,
  });

  setWhere = (data = {}) => {
    const { filter_type } = this.state;
    let where_fechas = {};
    let where = {};

    if (filter_type === 'pagos') {
      if (data.dateStart || data.dateEnd) {
        where_fechas = {
          PagosRealizados: {
            $inQuery: {
              where: {},
              className: 'SolicitudesPagosRealizados',
            },
          },
        };
        if (data.dateStart) {
          where_fechas.PagosRealizados.$inQuery.where.pagado_al = {
            ...(where_fechas.PagosRealizados.$inQuery.where.pagado_al || {}),
            $gte: data.dateStart,
          };
        }
        if (data.dateEnd) {
          where_fechas.PagosRealizados.$inQuery.where.pagado_al = {
            ...(where_fechas.PagosRealizados.$inQuery.where.pagado_al || {}),
            $lte: data.dateEnd,
          };
        }
      } else {
        where_fechas = { PagosRealizados: { $exists: true } };
      }

      where = _.extend(this.buildWhereBase(data), where_fechas);

      // Configuración extra
      this.order = '-pagado_al,-updatedAt';
      this.className = 'Solicitudes';
      this.include =
        'Grupo,Sucursal,promotor,montos,PagosRealizados, PagosRealizados.registrado_por,Pagos,registrado_por';
    } else if (filter_type === 'desembolsos' || filter_type === 'morosidad') {
      if (data.dateStart || data.dateEnd) {
        where_fechas = { fecha_elaboracion: {} };
        if (data.dateStart)
          where_fechas.fecha_elaboracion.$gte = data.dateStart;
        if (data.dateEnd) where_fechas.fecha_elaboracion.$lte = data.dateEnd;
      }

      where = _.extend(this.buildWhereBase(data), where_fechas);

      // Configuración extra
      this.order = '-fecha_elaboracion,-updatedAt';
      this.className = 'Solicitudes';
      this.include =
        'Grupo,Sucursal,promotor,montos,PagosRealizados,PagosRealizados.registrado_por,Pagos,registrado_por';
    }

    // Filtro general por fecha de creación
    const config = user.config();
    const filter_from =
      config && config.filter_from
        ? { $gte: { __type: 'Date', iso: config.filter_from } }
        : undefined;
    where.createdAt = filter_from;

    this.where = where;
    return where;
  };

  getXLS = () => {
    if (this.state.collection.length) {
      this.handleSpinner();

      const results = this.state.collectionAll;
      //console.log('results', results);
      const dateStr = new Date().toISOString().slice(0, 10);
      const fileName = `reporte-${this.state.filter_type}-${dateStr}.xlsx`;

      let transformedData = [];
      let headers = [];
      let sheetName = '';

      switch (this.state.filter_type) {
        case 'pagos':
          headers = [
            '#',
            'Grupo',
            'Nombre',
            'Registrado Por',
            'Ciclo',
            'Plazo',
            'Monto Pagado',
            'Fecha de Pago',
            'Promotor',
            'Sucursal',
            'Monto autorizado',
            'Total Pagos',
            'Capital',
            'Intereses',
            'Iva',
            'Interes + Iva',
            'Total',
          ];

          transformedData = results.map((req, idx) => ({
            index: idx + 1,
            Grupo: req.nombre_grupo || '',
            Nombre: req.cliente || '',
            'Registrado Por': req.registrado_por || '',
            Ciclo: this.setCicle(req) || '',
            Plazo: this.setPeriodisidad(req) || '',
            'Monto Pagado': req.pago || '',
            'Fecha de Pago': this.setLegibleDate(req.fecha_pago) || '',
            Promotor: req.promotor || '',
            Sucursal: req.sucursal || '',
            'Monto autorizado': req.montoAutorizado || '',
            'Total Pagos': req.sumPagos || '',
            Capital: req.capital || '',
            Intereses: req.interes || '',
            Iva: req.iva || '',
            'Interes + Iva': req.interes_mas_iva || '',
            Total: req.total || '',
          }));

          sheetName = 'Pagos';
          break;

        case 'desembolsos':
          headers = [
            '#',
            'Grupo',
            'Registrado Por',
            'Numero de Clientes',
            'Ciclo',
            'Plazo',
            'Pagos',
            'Monto Desembolsado',
            'Fecha de Desembolso',
            'Día Pago',
            'Fecha Final Contrato',
            'Promotor',
            'Sucursal',
          ];

          transformedData = results.map((req, idx) => ({
            index: idx + 1,
            Grupo: req.nombre_grupo || '',
            'Registrado Por': req.registrado_por || '',
            'Numero de Clientes': req.num_clientes || '',
            Ciclo: req.ciclo || '',
            Plazo: req.plazo || '',
            Pagos: req.num_pagos || '',
            'Monto Desembolsado': req.monto_desembolsado || '',
            'Fecha de Desembolso': req.fecha_desem || '',
            'Día Pago': req.dia_pago || '',
            'Fecha Final Contrato': req.fecha_fin_contrato
              ? req.fecha_fin_contrato
              : 'sin registro',
            Promotor: req.promotor || '',
            Sucursal: req.sucursal || '',
          }));

          sheetName = 'Desembolsos';
          break;

        default:
          alert('Tipo de filtro no soportado para descarga a Excel.');
          return;
      }

      // Crear hoja y aplicar encabezados
      const worksheet = XLSX.utils.json_to_sheet(transformedData);
      XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

      // Crear libro
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

      // Descargar
      XLSX.writeFile(workbook, fileName);
      this.handleSpinner();
    } else {
      alert('Realice un filtro para descargar el archivo Excel');
    }
  };

  downloadXLS = (xls) => {
    const s2ab = (s) => {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    };

    var bin = atob(xls);
    var ab = s2ab(bin); // from example above
    var blob = new Blob([ab], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;',
    });

    var link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    if (this.state.filter_type) {
      link.download = `reporte-${this.state.filter_type}.xlsx`;
    } else {
      link.download = 'pagos.xlsx';
    }

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);
  };

  handlePrintDocument = () => {
    if (this.state.collection.length === 0) {
      alert('Sin datos para descargar');
      return;
    }

    const results = this.state.collectionAll;

    this.handleSpinner();

    let generateData = (collectionAll) => {
      let result = [];
      switch (this.state.filter_type) {
        case 'pagos':
          result = _.map(collectionAll, (item) => {
            let data = {};
            data['#'] = '' + (item.index || '');
            data['Grupo'] = '' + (item.nombre_grupo || '');
            data['Registrado Por'] = '' + (item.registrado_por || '');
            data['Cliente'] = '' + (item.nombre_cliente || '');
            data['Ciclo'] = '' + (item.ciclo || '');
            data['Plazo'] = '' + (item.plazo || '');
            data['Pagado al'] =
              '' + (this.setLegibleDate(item.fecha_pago) || '');
            data['Monto pagado'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.pago);
            data['Monto Autorizado'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.montoAutorizado);
            data['Total Pagos'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.sumPagos);

            data['Capital'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.capital);
            data['Interés ordinario'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.interes);
            data['IVA'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.iva);
            data['Total'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.total);
            data['Pagos adelantados'] = '' + item.pagos_adelantados;
            data['Promotor'] = '' + (item.promotor || '');
            data['Sucursal'] = '' + (item.sucursal || '');
            return { ...data };
          });
          break;

        case 'desembolsos':
          result = _.map(collectionAll, (item) => {
            let data = {};
            data['#'] = '' + (item.index || '');
            data['Grupo'] = '' + (item.nombre_grupo || '');
            data['Registrado Por'] = '' + (item.registrado_por || '');
            data['# Clientes'] = '' + (item.num_clientes || '');
            data['Ciclo'] = '' + (item.ciclo || '');
            data['Plazo'] = '' + (item.plazo || '');
            data['# Pagos'] = '' + (item.num_pagos || '');
            data['Monto desem.'] = new Intl.NumberFormat('en', {
              style: 'currency',
              currency: 'USD',
            }).format(item.monto_desembolsado || 0);
            data['Fecha desem.'] = '' + (item.fecha_desem || '');
            data['Día pago'] = '' + (item.dia_pago || '');
            data['Fecha final contrato'] =
              '' +
              (item.fecha_fin_contrato
                ? item.fecha_fin_contrato
                : 'sin registro');
            data['Promotor'] = '' + (item.promotor || '');
            data['Sucursal'] = '' + (item.sucursal || '');
            return data;
          });
          break;
      }

      return result;
    };

    function createHeaders(keys) {
      return keys.map((k) => ({ id: k, name: k, prompt: k, padding: 0 }));
    }

    let headers;
    let title = '';
    let doc = new jsPDF({ orientation: 'landscape' });

    switch (this.state.filter_type) {
      case 'pagos':
        title = 'Reporte de pagos';
        headers = createHeaders([
          '#',
          'Grupo',
          'Registrado Por',
          'Cliente', // ← este sí lo generas como 'Ciente'
          'Ciclo',
          'Plazo',
          'Pagado al',
          'Monto pagado',
          'Capital',
          'Interés ordinario',
          'IVA',
          'Total',
          'Promotor',
          'Sucursal',
        ]);

        doc.setFontSize(20);
        doc.setTextColor(199, 137, 177);
        doc.text(title, 7, 10);
        doc.setTextColor(0, 0, 0);
        doc.table(7, 15, generateData(results), headers, {
          autoSize: true,
          fontSize: 9,
          padding: 1.5,
        });
        break;

      case 'desembolsos':
        title = 'Reporte de desembolsos';
        headers = createHeaders([
          '#',
          'Grupo',
          'Registrado Por',
          '# Clientes',
          'Ciclo',
          'Plazo',
          '# Pagos',
          'Monto desem.',
          'Fecha desem.',
          'Día pago',
          'Fecha final contrato',
          'Promotor',
          'Sucursal',
        ]);
        doc.setFontSize(20);
        doc.setTextColor(199, 137, 177);
        doc.text(title, 7, 10);
        doc.setTextColor(0, 0, 0);
        doc.table(1, 15, generateData(results), headers, {
          autoSize: true,
          fontSize: 7.5,
          padding: 0.8,
        });
        break;
    }

    doc.save(`reporte-${this.state.filter_type}.pdf`);
    this.handleSpinner();
  };

  componentDidMount = () => {};

  getResource = (index = 0, _where = {}) => {
    const currentFilterType = this.state.filter_type;
    const where = JSON.stringify(_where); // esto es solo si el backend lo requiere como string

    this.setState({ index }, () => {
      this.handleSpinner();

      switch (currentFilterType) {
        case 'pagos':
          Rest.peticion(`${config.api_url}/functions/getAllPaymentsData`, {
            method: 'POST',
            body: JSON.stringify({
              className: this.className,
              where: this.where,
              order: this.order,
              type: currentFilterType,
              index: parseInt(index),
              limit: this.limit,
            }),
          })
            .then((res) => {
              return res.json();
            })
            .then((res) => {
              // 🔧 FIX: Agregar validación defensiva aquí
              console.log('Respuesta completa del servidor:', res);

              if (!res || !res.result) {
                console.error('Respuesta inválida del servidor:', res);
                alert('Error: Respuesta inválida del servidor');
                return;
              }

              const result = res.result;
              this.rows = result.count || 0;

              console.log('res', res);
              let collection = this.getCollection(result);

              // Validación defensiva por si no existen valores
              if (!_.isEmpty(result.totals)) {
                collection.push({
                  monto_pago: result.totals.monto_pago ?? 0,
                  monto_pagado: result.totals.monto_pagado ?? 0,
                  pagos_adelantados: result.totals.pagos_adelantados ?? 0,
                  capital: result.totals.capital ?? 0,
                  interes: result.totals.interes ?? 0,
                  iva: result.totals.iva ?? 0,
                  total: result.totals.total ?? 0,
                });
              }

              this.setState({
                collection,
                total: this.rows,
                collectionAll: result.collection_all || [],
                rawResults: result,
              });
            })
            .catch((error) => {
              console.error('Error en pagos =>', error);
              alert('Ha ocurrido un error inesperado. Intente más tarde.');
            })
            .finally(() => {
              this.handleSpinner();
            });
          break;

        case 'desembolsos':
          Rest.peticion(`${config.api_url}/functions/getAllDisbursementData`, {
            method: 'POST',
            body: JSON.stringify({
              className: this.className,
              where: where, // usa el string serializado
              order: this.order,
              include: this.include,
              type: currentFilterType,
              skip: parseInt(index),
              limit: this.limit,
              format: 'json',
            }),
          })
            .then((res) => res.json())
            .then((res) => {
              this.rows = res.result.count;
              console.log('res', res);

              let collection = _.clone(res.result.results || []);
              console.log('collection', collection);

              if (!_.isEmpty(res.result.totals)) {
                collection.push({
                  monto_pago: res.result.totals.monto_pago ?? 0,
                  monto_desembolsado: res.result.totals.monto_desembolsado ?? 0,
                  num_clientes: res.result.totals.num_clientes ?? 0,
                  pagos_adelantados: res.result.totals.pagos_adelantados ?? 0,
                });
              }

              this.setState({
                collection,
                total: this.rows,
                collectionAll: res.result.collection_all,
                rawResults: res.result,
              });
            })
            .catch((error) => {
              console.error('Error en desembolsos =>', error);
              alert('Ha ocurrido un error inesperado. Intente más tarde.');
            })
            .finally(() => {
              this.handleSpinner();
            });
          break;

        default:
          console.warn('Tipo de filtro desconocido:', currentFilterType);
          break;
      }
    });
  };

  getCollection = (res) => {
    console.log('res-op-test-1', res);
    let collection = [];

    const days = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ];
    switch (this.state.filter_type) {
      case 'pagos':
        collection = _.map(res.results, (item, index) => {
          return {
            objectId: item.objectId,
            index: index + 1 + parseInt(this.state.index),
            nombre_grupo: item.nombre_grupo || '---',
            num_clientes: item.nombre_cliente || '---',
            registrado_por: item.registrado_por || 'Sin registro',
            ciclo: item.ciclo || 0,
            plazo: this.setPayText(item.plazo),
            pagado_al: item.fecha_pago
              ? this.setLegibleDate(item.fecha_pago)
              : '',
            monto_pagado: item.pago || 0,
            promotor: item.promotor,
            sumPagos: item.sumPagos || 0,
            montoAutorizado: item.montoAutorizado || 0,
            capital: item.capital || 0,
            interes: item.interes || 0,
            iva: item.iva || 0,
            total: item.total || 0,
            sucursal: item.sucursal || '---',
          };
        });
        break;

      case 'desembolsos':
        collection = _.map(res.results, (item, index) => {
          console.log('item', item);
          return {
            objectId: item.objectId,
            groupId: item.Grupo.objectId,
            index: index + 1 + parseInt(this.state.index),
            // Grupo
            nombre_grupo: item.Grupo.nombre,
            //Registrado por
            registrado_por: item.registrado_por || 'Sin registro',
            // Núm. Clientes
            num_clientes: item.montos.length,
            // Ciclo actual
            ciclo: this.setCicle(item),
            // Plazo
            plazo: this.setPeriodisidad(item),
            // Núm. Pagos
            num_pagos: this.setNumberPayments(item),
            // Monto desem.
            monto_desembolsado: this.setAuthorizedAmount(item),
            // Fecha desem.
            fecha_desem: this.setLegibleDate(item.fecha_elaboracion.iso),
            // Pago semanal
            monto_pago: this.setPay(item),
            // Pagos adelantados
            pagos_adelantados: this.setEquivalentPayments(item),
            // Día pago
            dia_pago: this.setPayday(item),
            // Fecha final contrato (reemplaza ultima_fecha_pago)
            fecha_fin_contrato: item.fecha_fin_contrato
              ? this.setLegibleDate(item.fecha_fin_contrato.iso)
              : 'Sin registro',
            // Promotor
            promotor: this.setPromotor(item),
            // Sucursal
            sucursal: this.setLugarRegistro(item.Sucursal),
          };
        });
        break;
    }
    return collection;
  };

  handleChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });

    return true;
  };

  handleSpinner = () => {
    this.setState((state) => ({
      loading: !state.loading,
    }));
  };

  setTableHead = () => {
    let tr;
    switch (this.state.filter_type) {
      case 'pagos':
        tr = (
          <tr>
            <th nowrap="true">#</th>
            <th nowrap="true">Grupo</th>
            <th nowrap="true">Nombre</th>
            <th nowrap="true">Registrado Por</th>
            <th nowrap="true">Ciclo</th>
            <th nowrap="true">Plazo</th>
            {/* <th nowrap="true">Pagos</th> */}
            {/* <th nowrap="true">Pago aplicado</th> */}
            <th nowrap="true">Pagado al</th>
            {/* <th nowrap="true">
              Monto pago{' '}
              <span className="no-show-pdf">
                <Popover
                  title="Monto de pago"
                  content="Es el pago semanal o catorcenal según sea el caso."
                />
              </span>
            </th> */}
            <th nowrap="true">Monto pagado</th>
            {/* <th nowrap="true">Pagos adelantados</th> */}
            {/* <th nowrap="true">Pagado <br/>al día</th> */}
            <th nowrap="true">Promotor</th>
            <th nowrap="true">Sucursal</th>
            <th nowrap="true">Monto Autorizado</th>
            <th nowrap="true">Total Pagos</th>
            <th nowrap="true">Capital</th>
            <th nowrap="true">Interés ordinario</th>
            <th nowrap="true">IVA</th>
            <th nowrap="true">Total</th>
          </tr>
        );
        break;
      case 'desembolsos':
        tr = (
          <tr>
            <th nowrap="true">#</th>
            <th nowrap="true">Grupo</th>
            <th nowrap="true">Registrado Por</th>
            <th nowrap="true"># Clientes</th>
            <th nowrap="true">Ciclo</th>
            <th nowrap="true">Plazo</th>
            {/* <th nowrap="true">Pagos</th> */}
            <th nowrap="true">Monto desem.</th>
            <th nowrap="true">
              Fecha desem.{' '}
              <TableOrder
                setOrder={this.setOrder}
                active={this.state.collection.length > 0}
                options={[
                  '-fecha_elaboracion,-updatedAt',
                  'fecha_elaboracion,-updatedAt',
                ]}
              />
            </th>
            <th nowrap="true">Fecha final contrato</th>
            <th nowrap="true">Promotor</th>
            <th nowrap="true">Sucursal</th>
          </tr>
        );
        break;
      default:
        break;
    }
    return tr;
  };

  setTableBody = () => {
    const { state } = this;
    let body;
    switch (this.state.filter_type) {
      case 'pagos':
        body = state.collection.map((item, index) => (
          <tr key={index} id={`solicitud-${item.objectId}`}>
            <td nowrap="true">{item.index}</td>
            <td nowrap="true">{item.nombre_grupo}</td>
            <td nowrap="true">{item.num_clientes}</td>
            <td nowrap="true">{item.registrado_por}</td>
            <td nowrap="true">{item.ciclo}</td>
            <td nowrap="true">{item.plazo}</td>
            {/* <td nowrap="true">{item.num_pagos}</td> */}
            {/* <td>{item.pago_aplicado}</td> */}
            <td nowrap="true">{item.pagado_al}</td>
            <td nowrap="true">
              {state.collection.length === index + 1 ? (
                <b>
                  {new Intl.NumberFormat('en', {
                    style: 'currency',
                    currency: 'USD',
                  }).format(item.monto_pagado)}
                </b>
              ) : (
                new Intl.NumberFormat('en', {
                  style: 'currency',
                  currency: 'USD',
                }).format(item.monto_pagado)
              )}
            </td>
            {/* <td nowrap="true">{
                        (state.collection.length === (index +1))? <b>{item.pagos_adelantados}</b> : item.pagos_adelantados
                    }</td> */}
            {/* <td nowrap="true" className="text-uppercase">{item.pagado_al_dia}</td> */}
            <td nowrap="true">{item.promotor}</td>
            <td nowrap="true">{item.sucursal}</td>
            <td nowrap="true">{item.montoAutorizado}</td>
            <td nowrap="true">{item.sumPagos}</td>
            <td nowrap="true">{item.capital}</td>
            <td nowrap="true">{item.interes}</td>
            <td nowrap="true">{item.iva}</td>
            <td nowrap="true">
              {state.collection.length === index + 1 ? (
                <b>
                  {new Intl.NumberFormat('en', {
                    style: 'currency',
                    currency: 'USD',
                  }).format(item.total)}
                </b>
              ) : (
                new Intl.NumberFormat('en', {
                  style: 'currency',
                  currency: 'USD',
                }).format(item.total)
              )}
            </td>
          </tr>
        ));
        break;
      case 'desembolsos':
        body = state.collection.map((item, index) => (
          <tr key={index} id={`solicitud-${item.objectId}`}>
            <td nowrap="true">{item.index}</td>
            <td nowrap="true">{item.nombre_grupo}</td>
            <td nowrap="true">{item.registrado_por}</td>
            <td nowrap="true">
              {state.collection.length === index + 1 ? (
                <b>
                  {new Intl.NumberFormat('en-MX').format(item.num_clientes)}
                </b>
              ) : (
                item.num_clientes
              )}
            </td>
            <td nowrap="true">{item.ciclo}</td>
            <td nowrap="true">{item.plazo}</td>
            {/* <td nowrap="true">{item.num_pagos}</td> */}
            <td nowrap="true">
              {state.collection.length === index + 1 ? (
                <b>
                  {new Intl.NumberFormat('en', {
                    style: 'currency',
                    currency: 'USD',
                  }).format(item.monto_desembolsado)}
                </b>
              ) : (
                new Intl.NumberFormat('en', {
                  style: 'currency',
                  currency: 'USD',
                }).format(item.monto_desembolsado)
              )}
            </td>
            <td nowrap="true">{item.fecha_desem}</td>
            <td nowrap="true">
              {item.fecha_fin_contrato
                ? item.fecha_fin_contrato
                : 'sin registro'}
            </td>
            <td nowrap="true">{item.promotor}</td>
            <td nowrap="true">{item.sucursal}</td>
          </tr>
        ));
        break;
    }

    return body;
  };

  handleChangeFilterType = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
      total: 0,
      collection: [],
    });
    return true;
  };

  setCicle = (requisition) => {
    return requisition.ciclo;
  };

  setPayText = (number) => {
    let text = '';
    switch (number) {
      case 7:
        text = 'SEMANAL';
        break;
      case 14:
        text = 'CATORCENAL';
        break;
      case 28:
        text = 'BICATORCENAL';
        break;
      default:
        text = 'SEMANAL';
        break;
    }
    return text;
  };

  setPeriodisidad = (requisition) => {
    return this.setPayText(requisition.prestamo_personalizado_periodicidad);
  };

  setLegibleDate = (date_iso) => {
    const _days = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
      '13',
      '14',
      '15',
      '16',
      '17',
      '18',
      '19',
      '20',
      '21',
      '22',
      '23',
      '24',
      '25',
      '26',
      '27',
      '28',
      '29',
      '30',
      '31',
    ];
    const _months = [
      '01',
      '02',
      '03',
      '04',
      '05',
      '06',
      '07',
      '08',
      '09',
      '10',
      '11',
      '12',
    ];

    const theDate = new Date(date_iso);
    return `${_days[theDate.getDate() - 1]}/${
      _months[theDate.getMonth()]
    }/${theDate.getFullYear()}`;
  };

  setPayday = (requisition) => {
    if (requisition.dia_pago) {
      const days = [
        'Domingo',
        'Lunes',
        'Martes',
        'Miércoles',
        'Jueves',
        'Viernes',
        'Sábado',
      ];
      return days[requisition.dia_pago].toUpperCase();
    } else {
      return <i>No especificado</i>;
    }
  };

  setEquivalentPayments = (requisition) => {
    let total = 0;
    if (requisition.ciclo > 1) {
      try {
        requisition = _.findWhere(requisition.Grupo.Solicitudes, {
          ciclo: requisition.ciclo - 1,
        });
        if (requisition.PagosRealizados !== undefined) {
          let gte;
          let lte;
          switch (this.state.filter_type) {
            case 'pagos':
              // eslint-disable-next-line no-mixed-operators
              gte =
                (this.where.Pagos.$inQuery &&
                  this.where.Pagos.$inQuery.where.fecha_pago.$gte) ||
                undefined;
              // eslint-disable-next-line no-mixed-operators
              lte =
                (this.where.Pagos.$inQuery &&
                  this.where.Pagos.$inQuery.where.fecha_pago.$lte) ||
                undefined;

              // si hay rango de fecha
              if (!_.isEmpty(lte) && !_.isEmpty(gte)) {
                const dateStart = new Date(gte.iso).getTime();
                const dateEnd = new Date(lte.iso).getTime();

                for (
                  let index = 0;
                  index < requisition.PagosRealizados.length;
                  index++
                ) {
                  const datePay = new Date(
                    requisition.PagosRealizados[index].pagado_al.iso
                  );
                  if (datePay >= dateStart && datePay <= dateEnd) {
                    total +=
                      Math.floor(
                        requisition.PagosRealizados[index].pagos_adelantados /
                          requisition.montos.length
                      ) || 0;
                  }
                }
                // si hay fecha mínima
              } else if (!_.isEmpty(gte)) {
                const dateStart = new Date(gte.iso).getTime();

                for (
                  let index = 0;
                  index < requisition.PagosRealizados.length;
                  index++
                ) {
                  const datePay = new Date(
                    requisition.PagosRealizados[index].pagado_al.iso
                  );
                  if (datePay >= dateStart) {
                    total +=
                      Math.floor(
                        requisition.PagosRealizados[index].pagos_adelantados /
                          requisition.montos.length
                      ) || 0;
                  }
                }
                // si hay fecha máxima
              } else if (!_.isEmpty(lte)) {
                const dateEnd = new Date(lte.iso).getTime();

                for (
                  let index = 0;
                  index < requisition.PagosRealizados.length;
                  index++
                ) {
                  const datePay = new Date(
                    requisition.PagosRealizados[index].pagado_al.iso
                  );
                  if (datePay <= dateEnd) {
                    total +=
                      Math.floor(
                        requisition.PagosRealizados[index].pagos_adelantados /
                          requisition.montos.length
                      ) || 0;
                  }
                }
                // si no hay rango de fecha
              } else {
                for (
                  let index = 0;
                  index < requisition.PagosRealizados.length;
                  index++
                ) {
                  total +=
                    Math.floor(
                      requisition.PagosRealizados[index].pagos_adelantados /
                        requisition.montos.length
                    ) || 0;
                }
              }
              break;
            case 'desembolsos':
              for (
                let index = 0;
                index < requisition.PagosRealizados.length;
                index++
              ) {
                total +=
                  requisition.PagosRealizados[index].pagos_adelantados || 0;
              }
              total = Math.floor(total / requisition.montos.length);
              break;
          }
        }
      } catch (error) {
        console.error(error);
        total = 0;
      }
    }
    return total;
  };

  setEquivalentPaymentsTotal = (requisitions) => {
    let total = 0;
    _.each(requisitions, (item) => {
      total += item.pagos_adelantados || 0;
    });
    return total;
  };

  lastPaymentRecord = (requisition) => {
    const montos = requisition.montos;
    let fechas = _.pluck(montos, 'ultima_fecha_pago');
    fechas = _.compact(fechas);
    if (!_.isEmpty(fechas)) {
      const marcasTiempo = _.map(fechas, (fecha) => {
        if (fecha) {
          return new Date(fecha.iso).getTime();
        }
      });
      const fechaMasActual = _.max(marcasTiempo);
      return new Date(fechaMasActual).toLocaleDateString();
    } else {
      return <i>Sin fecha</i>;
    }
  };

  lastPayDay = (requisition) => {
    console.log('requisition', requisition);
    let last_date = 'Sin registro';
    try {
      const last_pay = _.max(requisition.Pagos, (pago) => {
        return pago.numero_pago;
      });
      last_date = new Date(last_pay.fecha_pago.iso).toLocaleDateString();
    } catch (error) {
      console.error(error);
    }
    return last_date;
  };

  setNumberPayments = RequisitionModel.setNumberPayments;

  setPromotor = (solicitud) => {
    const promotor = solicitud.promotor;
    return `${promotor.nombre} ${promotor.apellido_paterno} ${promotor.apellido_materno}`;
  };

  setLugarRegistro = (lugar) => {
    if (!_.isEmpty(lugar)) {
      return lugar.nombre;
    } else {
      return '';
    }
  };

  setOrder = (order) => {
    this.order = order;
    this.getResource(this.state.index, this.where);
  };

  handleFilter = async (event) => {
    if (event) event.preventDefault();

    const state = this.state;

    let dateStart = undefined;
    if (_.isDate(state.dateStart)) {
      dateStart = new Date(state.dateStart);
      dateStart.setHours(0, 0, 0, 0);
    }

    let dateEnd = undefined;
    if (_.isDate(state.dateEnd)) {
      dateEnd = new Date(state.dateEnd);
      dateEnd.setHours(23, 59, 59, 999);
    }

    let where = {
      dateStart: dateStart
        ? {
            __type: 'Date',
            iso: dateStart.toISOString(),
          }
        : undefined,
      dateEnd: dateEnd
        ? {
            __type: 'Date',
            iso: dateEnd.toISOString(),
          }
        : undefined,
    };

    where = this.setWhere(where);

    // Guardamos el filtro para enviar al hijo
    this.setState({ where });

    this.rows = 0;
    this.getResource(0, where);
  };

  handleChangeDate = (date, name) => {
    this.setState({
      [name]: date,
    });
  };

  setData = (data) => {
    this.data = data;
  };

  render() {
    const { state } = this;
    return (
      <>
        <Spinner loading={state.loading} />
        <h3 className="text-uppercase text-pink pt-3 pb-3">
          <i className="fas fa-file-alt mr-2"></i>
          {this.title}
        </h3>
        <div className="card">
          <div className="card-body">
            <div className="row mt-1">
              <div className="col-md-4">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <label className="input-group-text" htmlFor="filter_type">
                      Tipo
                    </label>
                  </div>
                  <select
                    className="form-control"
                    id="filter_type"
                    name="filter_type"
                    value={this.state.filter_type}
                    onChange={this.handleChangeFilterType}
                  >
                    <option value="desembolsos">DESEMBOLSOS</option>
                    <option value="pagos">PAGOS</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="m-4"></div>
            <DisbursmentAndPaymentFilter
              handleChange={this.handleChange}
              handleChangeDate={this.handleChangeDate}
              handleFilter={this.handleFilter}
              state={state}
            />
            <div className="m-4"></div>
            <div className="text-right">
              <div className="btn-group" role="group" aria-label="Descargas">
                <button
                  className="btn btn-secondary"
                  onClick={() => this.getXLS()}
                >
                  Descargar Excel
                </button>
                <button
                  className="btn btn-secondary"
                  onClick={() => this.handlePrintDocument()}
                >
                  Descargar PDF
                </button>
              </div>
            </div>
            <div className="m-4"></div>
            {/* <div className="text-right">
                            <div className="btn-group" role="group" aria-label="Descargas">
                                <button className="btn btn-secondary" onClick={() => this.getXLS()}>Descargar Excel</button>
                                <button className="btn btn-secondary" onClick={() => this.handlePrintDocument()}>Descargar PDF</button>
                            </div>
                        </div> */}

            {/* {state.collection.length > 0 ? (
              <div className="text-right">
                <div className="btn-group" role="group">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    data-toggle="modal"
                    data-target="#modal-createPolice-form"
                    data-backdrop="static"
                    data-keyboard="false"
                  >
                    Generar póliza
                  </button>
                </div>
              </div>
            ) : (
              <></>
            } */}

            {/* <div className='text-right'>
                            <div className="btn-group" role="group">
                                <button type="button" className="btn btn-primary btn-block" data-toggle="modal" data-target="#modal-createPolice-form" data-backdrop="static" data-keyboard="false">
                                    Generar póliza
                                </button>
                            </div>
                        </div> */}

            <TableCountInfo total={state.total} />

            <div id="table-pdf" className="table-responsive" ref={this.ref}>
              <table className="table">
                <thead>{this.setTableHead()}</thead>

                <tbody>
                  {(state.collection.length > 0 &&
                    // eslint-disable-next-line no-mixed-operators
                    this.setTableBody()) || (
                    // eslint-disable-next-line no-mixed-operators
                    <tr>
                      <td colSpan="16" className="text-center">
                        <div className="alert alert-warning m-0" role="alert">
                          No se hallaron registros
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="row align-items-center">
              <div className="col-md-6">
                <TableCountInfo total={this.state.total} />
              </div>
              <div className="col-md-6">
                <TablePagination
                  index={this.state.index}
                  align="end"
                  limit={this.limit}
                  rows={this.rows}
                  getData={this.getResource}
                  where={this.where}
                />
              </div>
            </div>
          </div>

          <CreatePoliceForm
            id="modal-createPolice-form"
            filter_type={this.state.filter_type}
            collectionAll={this.state.collectionAll}
            setData={this.setData}
            fecha={this.state.dateStart}
          />
        </div>
        <div className="p-5"></div>
      </>
    );
  }
}

export default ListDisbursmentAndPayment;
